<template>
  <div  v-loading="loading2" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"  >
    <pull-to :top-load-method="touchtop"   :bottom-load-method="touchbottom" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG" >

    <div class="box"
     >
  <div class="asstsCard" :key="item.key"  v-for="item in asstsList" @click="cxStart(item.id)">
    <p class="asstsCardTitle">总资产</p>
    <div class="asstsCardClick" v-if="item.tagName !== ''">{{item.tagName}}</div>
    <div class="asstsCardClick" v-if="item.tagName === ''">我要标记他</div>
    <p class="asstsCardNum">{{item.allprice}}<span>USD</span></p>
    <p class="asstsCardAddres">{{item.walletAddress}}</p>
    <p class="asstsCardNowTips" v-if="item.tagInfo.length === 1">被{{item.tagInfo[0].count}}人标记为“{{item.tagInfo[0].name}}”</p>
    <p class="asstsCardNowTips" v-if="item.tagInfo.length === 2">被{{item.tagInfo[0].count}}人标记为“{{item.tagInfo[0].name}}” {{item.tagInfo[1].count}}人标记为“{{item.tagInfo[1].name}}”</p>
  </div>

  <div class="successTip" v-if="TipStutas">
    {{TipStutasText}}
  </div>
    </div>
    </pull-to>

  </div>
</template>

<script>
import Config from '../config/index'
import callApi from '../../static/callApi'
import PullTo from 'vue-pull-to'

export default {
  name: 'asstsHistroy',
  components: {
    PullTo
  },
  data () {
    return {
      loading2: false,
      pageIndex: 1,
      TipStutas: false,
      TipStutasText: '',
      asstsList: [],
      count: 1,
      TOP_DEFAULT_CONFIG: {
        pullText: '1', // 下拉时显示的文字
        triggerText: '1', // 下拉到触发距离时显示的文字
        loadingText: '1...', // 加载中的文字
        doneText: '1', // 加载完成的文字
        failText: '1', // 加载失败的文字
        loadedStayTime: 400, // 加载完后停留的时间ms
        stayDistance: 50, // 触发刷新后停留的距离
        triggerDistance: 70 // 下拉刷新触发的距离
      },
      BOTTOM_DEFAULT_CONFIG: {
        pullText: '1',
        triggerText: '1',
        loadingText: '1...',
        doneText: '1',
        failText: '1',
        loadedStayTime: 400,
        stayDistance: 50,
        triggerDistance: 70
      }
    }
  },
  created: function () {
    if (this.$route.query.uid) {
      this.loading2 = true
      this.token = this.$route.query.token
      this.uuid = this.$route.query.uuid
      this.uid = this.$route.query.uid
      this.getAsstsHistroy()
    }
  },
  methods: {
    getAsstsHistroy: function () {
      this.loading2 = true
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/asset/queryHistory',
        headers: {uuid: this.uuid, versioncode: 1.0, platform: 'smallprogram', uid: this.uid, token: this.token},
        params: {pageIndex: this.pageIndex, uid: this.uid}
      }, (response) => {
        if (response.data.success === '1') {
          let list = response.data.content.history
          for (let n in list) {
            let allp = 0
            for (let i = 0; i < list[n].assetInfo.length; i++) {
              allp += list[n].assetInfo[i].balance * list[n].assetInfo[i].price
            }
            list[n].allprice = allp.toFixed(2)
            list[n].key = n
          }
          _this.count = (response.data.content.totalCount % 10) !== 0 ? parseInt(response.data.content.totalCount / 10) + 1 : parseInt(response.data.content.totalCount / 10)
          _this.asstsList = list
          _this.loading2 = false
        } else {
          _this.openmessage(response.data.message)
          _this.loading2 = false
        }
      }, this)
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    cxStart: function (id) {
      this.$router.push({path: '/asstsQuery', query: {cxAsstsId: id, token: this.token, uuid: this.uuid, uid: this.uid}})
    },
    touchtop: function (loaded) {
      loaded('done')
      if (this.pageIndex > 1) {
        this.pageIndex = this.pageIndex - 1
        this.getAsstsHistroy()
      }
    },
    touchbottom: function (loaded) {
      loaded('done')
      if (this.pageIndex < this.count) {
        this.pageIndex = this.pageIndex + 1
        this.getAsstsHistroy()
      }
    }
  }
}
</script>
<style scoped>
  .box{
    background-image: url('http://images.growup.link/assts/image/backgroundZTx1.png');
    background-size: 100% auto;
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .asstsCard{
    width: 9.0667rem;
    height: 3.7333rem;
    margin: 0.4667rem auto;
    background-image: linear-gradient(-156deg, #2DA2FC 0%, #0372C7 96%);
    border-radius: 0.26667rem;
    box-shadow: 0 0.45rem 0.26667rem 0px #0000009c;
    position: relative;
  }
  .asstsCard .asstsCardTitle{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.4rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 0.56rem;
  }
  .asstsCard .asstsCardClick{
    font-family: PingFangSC-Semibold;
    font-size: 0.4rem;
    color: #ffffff;
    text-align: right;
    position: absolute;
    right: 0.507rem;
    top: 0.56rem;
  }
  .asstsCard .asstsCardNum{
    /* 417245.06: */
    font-family: PingFangSC-Medium;
    font-size: 0.9333rem;
    color: #FFFFFF;
    letter-spacing: -0.0349rem;
    position: absolute;
    left: 0.507rem;
    top: 1.24rem;
  }
  .asstsCard .asstsCardNum span{
    /* USD: */
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.4rem;
    color: #FFFFFF;
    margin-left: 0.447rem;
  }
  .asstsCard .asstsCardAddres{
    /* 0x543E56a8923613D292: */
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.293rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 2.48rem;
    text-overflow: ellipsis;
    width: 8.0667rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .asstsCard .asstsCardNowTips{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.293rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 2.9733rem;
  }
  .successTip{
    opacity: 0.8;
    background: #000000;
    border-radius: 0.267rem;
    position: fixed;
    top: 7.147rem;
    left: 50%;
    transform: translateX(-50%);
    height: 2.66667rem;
    width: 5.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000
  }
</style>



// WEBPACK FOOTER //
// src/components/asstsHistroy.vue